import type { RecorderLoggingEventType } from "../common/logging/recorderClientLogging";

export class RecorderError extends Error {
    public readonly recorderEventType: RecorderLoggingEventType;
    public readonly cause?: Error | ErrorEvent;

    constructor(
        message: string,
        recorderEventType: RecorderLoggingEventType,
        cause?: Error | ErrorEvent
    ) {
        super(message);

        this.name = this.constructor.name;
        this.recorderEventType = recorderEventType;
        this.cause = cause;

        Object.setPrototypeOf(this, new.target.prototype);

        if (cause instanceof Error && cause?.stack) {
            this.stack += `\nCaused by: ${cause.stack}`;
        }
    }
}
